import ChargeRepaymentProvider from "enums/ChargeRepaymentProvider";

const PROVIDER_LABELS: Record<string, string> = {
  [ChargeRepaymentProvider.HIGHNOTE]: "Highnote",
  [ChargeRepaymentProvider.OATFI]: "OatFi",
};

/** Brand names are data, never translated. */
export const chargeRepaymentProviderLabel = (
  provider?: string | null,
): string => (provider && PROVIDER_LABELS[provider]) || "";

export default chargeRepaymentProviderLabel;
